/* eslint-disable import/no-relative-packages */
import React, { FC, useMemo } from "react";
import ReactDOMServer from "react-dom/server";

// eslint-disable-next-line node/no-missing-import
import type * as CSS from "csstype";

// React-icons:
// startReplaceSection1
import * as ai from "../../libs/react-icons-min/ai/index.mjs";
import * as bi from "../../libs/react-icons-min/bi/index.mjs";
import * as bs from "../../libs/react-icons-min/bs/index.mjs";
import * as cg from "../../libs/react-icons-min/cg/index.mjs";
import * as ci from "../../libs/react-icons-min/ci/index.mjs";
import * as di from "../../libs/react-icons-min/di/index.mjs";
import * as fa from "../../libs/react-icons-min/fa/index.mjs";
import * as fa6 from "../../libs/react-icons-min/fa6/index.mjs";
import * as fc from "../../libs/react-icons-min/fc/index.mjs";
import * as fi from "../../libs/react-icons-min/fi/index.mjs";
import * as gi from "../../libs/react-icons-min/gi/index.mjs";
import * as go from "../../libs/react-icons-min/go/index.mjs";
import * as gr from "../../libs/react-icons-min/gr/index.mjs";
import * as hi2 from "../../libs/react-icons-min/hi2/index.mjs";
import * as im from "../../libs/react-icons-min/im/index.mjs";
import * as io from "../../libs/react-icons-min/io/index.mjs";
import * as lia from "../../libs/react-icons-min/lia/index.mjs";
import * as lu from "../../libs/react-icons-min/lu/index.mjs";
import * as md from "../../libs/react-icons-min/md/index.mjs";
import * as pi from "../../libs/react-icons-min/pi/index.mjs";
import * as ri from "../../libs/react-icons-min/ri/index.mjs";
import * as si from "../../libs/react-icons-min/si/index.mjs";
import * as sl from "../../libs/react-icons-min/sl/index.mjs";
import * as tb from "../../libs/react-icons-min/tb/index.mjs";
import * as ti from "../../libs/react-icons-min/ti/index.mjs";
import * as vsc from "../../libs/react-icons-min/vsc/index.mjs";
// endReplaceSection1
import gcIcons from "./gcIcons.tsx";

// eslint-disable-next-line import/no-relative-packages
import { IconContext } from "../../libs/react-icons-min/lib/index.mjs";

const { rz, $ } = window;

type componentProps = {
  icopath:string,
  className?:string,
  style?:React.CSSProperties | CSS.Properties,
  attrs?:{[key:string]: string | boolean | number | React.ReactNode},
  color?:string,
  bgcolor?:string,
  size?:string|number,
  // eslint-disable-next-line react/boolean-prop-naming
  gethtml?:boolean | "true" | "false"
};
const AppIcons:FC<componentProps> = ({icopath, attrs, style, color, bgcolor, size, className}) => { // icoClassName
  // const theme = useAppSelector(getTheme);
  const theme = $("html").attr("data-theme");
  // @ts-ignore
  const fullpath = (icopath || (attrs && (attrs.icon || attrs.icopath || attrs.path)) || "").trim().split("/");

  const color1 = useMemo(() => {
    let clr:string | undefined;
    if (color) {
      const allc = color.split("|");
      if (allc.length > 1) { clr = (theme === "dark" ? allc[1] : allc[0]) } else { clr = allc[0] }
    }
    else if (attrs && attrs.color && rz.isString(attrs.color)) {
      const allc = (attrs.color as string).split("|");
      if (allc.length > 1) { clr = (theme === "dark" ? allc[1] : allc[0]) } else { clr = allc[0] }
    }
    return clr;
  }, [attrs, color, theme]);

  const bgcolor1 = useMemo(() => {
    let clr:string | undefined;
    if (bgcolor) {
      const allc = bgcolor.split("|");
      if (allc.length > 1) { clr = (theme === "dark" ? allc[1] : allc[0]) } else { clr = allc[0] }
    }
    else if (attrs && attrs.bgcolor && rz.isString(attrs.bgcolor)) {
      const allc = (attrs.bgcolor as string).split("|");
      if (allc.length > 1) { clr = (theme === "dark" ? allc[1] : allc[0]) } else { clr = allc[0] }
    }
    return clr;
  }, [attrs, bgcolor, theme]);

  const className1 = useMemo(() => {
    let clsName:string | undefined;
    if (className) {
      const allc = className.split("|");
      if (allc.length > 1) { clsName = (theme === "dark" ? allc[1] : allc[0]) } else { clsName = allc[0] }
    }
    else if (attrs && attrs.className && rz.isString(attrs.className)) {
      const allc = (attrs.className as string).split("|");
      if (allc.length > 1) { clsName = (theme === "dark" ? allc[1] : allc[0]) } else { clsName = allc[0] }
    }
    return clsName;
  }, [attrs, className, theme]);

  let Rico;
  if (fullpath && fullpath[0] && fullpath[1]) {
    switch (fullpath[0]) {
      // startReplaceSection2
      case "ai": Rico = ai[fullpath[1]]; break;
      case "bi": Rico = bi[fullpath[1]]; break;
      case "bs": Rico = bs[fullpath[1]]; break;
      case "cg": Rico = cg[fullpath[1]]; break;
      case "ci": Rico = ci[fullpath[1]]; break;
      case "di": Rico = di[fullpath[1]]; break;
      case "fa": Rico = fa[fullpath[1]]; break;
      case "fa6": Rico = fa6[fullpath[1]]; break;
      case "fc": Rico = fc[fullpath[1]]; break;
      case "fi": Rico = fi[fullpath[1]]; break;
      case "gi": Rico = gi[fullpath[1]]; break;
      case "go": Rico = go[fullpath[1]]; break;
      case "gr": Rico = gr[fullpath[1]]; break;
      case "hi2": Rico = hi2[fullpath[1]]; break;
      case "im": Rico = im[fullpath[1]]; break;
      case "io": Rico = io[fullpath[1]]; break;
      case "lia": Rico = lia[fullpath[1]]; break;
      case "lu": Rico = lu[fullpath[1]]; break;
      case "md": Rico = md[fullpath[1]]; break;
      case "pi": Rico = pi[fullpath[1]]; break;
      case "ri": Rico = ri[fullpath[1]]; break;
      case "si": Rico = si[fullpath[1]]; break;
      case "sl": Rico = sl[fullpath[1]]; break;
      case "tb": Rico = tb[fullpath[1]]; break;
      case "ti": Rico = ti[fullpath[1]]; break;
      case "vsc": Rico = vsc[fullpath[1]]; break;
      // endReplaceSection2
      case "gc": Rico = gcIcons; break;
      default:
    }
  }

  // eslint-disable-next-line react/no-unknown-property
  if (!Rico) return (<div className="errorIcon" uk-tooltip="Error Icon Path" />);

  if (attrs?.getHTML || attrs?.gethtml === true || attrs?.gethtml === "true") {
    return ReactDOMServer.renderToStaticMarkup( // renderToString
      // @ts-ignore
      <IconContext.Provider value={{...attrs, color: color1}}>
        <Rico key={attrs?.key || icopath} id={attrs?.key || icopath} icopath={icopath} icocolor={color1} bgcolor={bgcolor1}
          style={style} className={className1}
          uk-tooltip={attrs ? (attrs.tooltip || attrs["uk-tooltip"]) : undefined} size={attrs ? attrs.size : size}
        />
      </IconContext.Provider>
    );
  }

  return (
    // @ts-ignore
    <IconContext.Provider value={{...attrs, color: color1}}>
      <Rico key={attrs?.key || icopath} id={attrs?.key || icopath} icopath={icopath} icocolor={color1} bgcolor={bgcolor1}
        style={style} className={className1}
        uk-tooltip={attrs ? (attrs.tooltip || attrs["uk-tooltip"]) : undefined} size={attrs ? attrs.size : size}
      />
    </IconContext.Provider>
  );
}

export default AppIcons;
